import { createAsyncThunk } from '@reduxjs/toolkit';

import { FetchMetaResponse } from '../../types/OrderSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const fetchMetaInfo = createAsyncThunk<
    FetchMetaResponse,
    { id: string },
    ThunkConfig<string>
>('order/fetchMetaInfo', async ({ id }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.get<FetchMetaResponse>(
            `/v1/orders/${id}/meta`,
        );

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
